import { render, staticRenderFns } from "./mai6.vue?vue&type=template&id=5ecddac8&scoped=true&"
import script from "./mai6.vue?vue&type=script&lang=ts&"
export * from "./mai6.vue?vue&type=script&lang=ts&"
import style0 from "./mai6.vue?vue&type=style&index=0&id=5ecddac8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecddac8",
  null
  
)

export default component.exports